<template>
  <div class="wrap">
    <div class="join">
      <div class="container">
        <div class="join_wrap">
          <div class="join_title">회원 가입 유형 선택</div>
          <div class="join_type">
            <!-- <a href="/join_step" class="con_box"> -->
            <a class="con_box" @click="moveToJoinStep('private')">
              <img src="/assets/images/layout/re_join_common.png" />
              <span>일반 회원 가입하기</span>
            </a>

            <!-- <a href="/join_step" class="con_box none_event"> -->
            <a class="con_box none_event" @click="moveToJoinStep('group')">
              <img src="/assets/images/layout/rejoin_student.png" />
              <span style="background-color: #8e8e8e"
                >기업・단체 회원 가입</span
              >
            </a>
          </div>
          <div class="join_description">
            <div class="img">
              <img src="/assets/images/layout/re_alarm.png" />
            </div>
            <div class="txt">
              기업・단체 소속으로 라온 메타데미 수강 과목이<br />
              정해진 경우, 해당 부서에 계정 정보를 문의해 주세요.
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <ModalAlertJoinEnter
        :alertMsg="errMsg"
        :isOpen="errStatus"
        @update:isOpen="updateStatus"
      />
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import ModalAlertJoinEnter from '../components/ModalAlertJoinEnter.vue'

// ModalAlertJoinEnter
export default {
  name: 'JoinEnterView',
  components: {
    ModalAlertJoinEnter,
  },
  setup() {
    const router = useRouter()

    const errMsg = ref('')
    const errStatus = ref(false)
    const updateStatus = () => {
      errStatus.value = false
    }
    // const privateMember = ref(false)
    // const groupMember = ref(false)
    const moveToJoinStep = (type) => {
      if (type === 'private') {
        localStorage.setItem('joinType', 'IDV')

        router.push({
          path: '/join_step',
          name: 'JoinStepView',
        })
      } else {
        errMsg.value =
          '현재는 일반 회원 가입만 가능합니다.<br> 기업・단체 회원 가입은 소속 단체로 문의해 주세요.'
        errStatus.value = true
        // localStorage.setItem('joinType', 'GRP')
      }
    }
    return {
      errMsg,
      errStatus,
      updateStatus,
      // privateMember,
      // groupMember,
      moveToJoinStep,
    }
  },
}
</script>

<style></style>
